// // NotificationBell.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { Bell, Check, Briefcase, FileText, X } from 'lucide-react';
// import axios from 'axios';
// import { COMPANY_API_END_POINT } from '@/utils/constant';
// import { APP } from './DashbordApplicationTab';
// import { socket } from "@/socket";

// const NOTIF_ICONS = {
//   application: FileText,
//   job: Briefcase,
//   default: Bell,
// };

// const NotificationBell = () => {
//   const [open, setOpen] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const dropdownRef = useRef(null);

//   const fetchNotifications = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${COMPANY_API_END_POINT}/notifications`, {
//         withCredentials: true,
//       });
//       if (res.data.status) {
//         setNotifications(res.data.notifications || []);
//         setUnreadCount(res.data.unreadCount || 0);
//       }
//     } catch (err) {
//       console.error('Notification fetch error:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const markAsRead = async (id) => {
//     try {
//       await axios.patch(`${COMPANY_API_END_POINT}/notifications/${id}/read`, {}, {
//         withCredentials: true,
//       });
//       setNotifications(prev =>
//         prev.map(n => n._id === id ? { ...n, read: true } : n)
//       );
//       setUnreadCount(prev => Math.max(0, prev - 1));
//     } catch (err) {
//       console.error('Mark read error:', err);
//     }
//   };

//   const markAllAsRead = async () => {
//     try {
//       await axios.patch(`${COMPANY_API_END_POINT}/notifications/read-all`, {}, {
//         withCredentials: true,
//       });
//       setNotifications(prev => prev.map(n => ({ ...n, read: true })));
//       setUnreadCount(0);
//     } catch (err) {
//       console.error('Mark all read error:', err);
//     }
//   };

//   // Close on outside click
//   useEffect(() => {
//     const handleClick = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClick);
//     return () => document.removeEventListener('mousedown', handleClick);
//   }, []);

//   // Poll for new notifications every 30s
//   useEffect(() => {
//     fetchNotifications();
//     const interval = setInterval(fetchNotifications, 30 * 1000);
//     return () => clearInterval(interval);
//   }, []);

//   const timeAgo = (date) => {
//     const seconds = Math.floor((new Date() - new Date(date)) / 1000);
//     if (seconds < 60) return 'Just now';
//     const minutes = Math.floor(seconds / 60);
//     if (minutes < 60) return `${minutes}m ago`;
//     const hours = Math.floor(minutes / 60);
//     if (hours < 24) return `${hours}h ago`;
//     const days = Math.floor(hours / 24);
//     return `${days}d ago`;
//   };

//   return (
//     <div className="relative" ref={dropdownRef}>
//       <button
//   onClick={() => setOpen(!open)}
//   style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textSm }}
//   className="relative p-2 border rounded-lg hover:bg-slate-50 transition-colors w-11 h-11 flex items-center justify-center">
//   <Bell size={16} />
//   {unreadCount > 0 && (
//     <span
//       style={{ backgroundColor: APP.red }}
//       className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full text-white text-[10px] font-bold flex items-center justify-center">
//       {unreadCount > 9 ? '9+' : unreadCount}
//     </span>
//   )}
// </button>

//       {open && (
//         <div
//           style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//           className="absolute right-0 mt-2 w-80 rounded-2xl shadow-lg z-50 overflow-hidden">

//           {/* Header */}
//           <div style={{ borderBottom: `1px solid ${APP.borderLight}` }}
//             className="flex items-center justify-between px-4 py-3">
//             <h3 style={{ color: APP.text }} className="text-sm font-semibold">Notifications</h3>
//             {unreadCount > 0 && (
//               <button
//                 onClick={markAllAsRead}
//                 style={{ color: APP.primary }}
//                 className="text-xs font-medium hover:underline">
//                 Mark all as read
//               </button>
//             )}
//           </div>

//           {/* List */}
//           <div className="max-h-96 overflow-y-auto">
//             {loading && notifications.length === 0 ? (
//               <p style={{ color: APP.textXs }} className="text-sm text-center py-8">Loading...</p>
//             ) : notifications.length === 0 ? (
//               <div className="text-center py-8">
//                 <Bell size={24} style={{ color: APP.textXs }} className="mx-auto mb-2" />
//                 <p style={{ color: APP.textXs }} className="text-sm">No notifications yet</p>
//               </div>
//             ) : (
//               notifications.map((n) => {
//                 const Icon = NOTIF_ICONS[n.type] || NOTIF_ICONS.default;
//                 return (
//                   <div
//                     key={n._id}
//                     onClick={() => !n.read && markAsRead(n._id)}
//                     style={{
//                       backgroundColor: n.read ? APP.card : APP.primaryBg,
//                       borderBottom: `1px solid ${APP.borderLight}`,
//                     }}
//                     className="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-slate-50 transition-colors">
//                     <div
//                       style={{ backgroundColor: APP.primaryBg, color: APP.primary }}
//                       className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
//                       <Icon size={14} />
//                     </div>
//                     <div className="flex-1 min-w-0">
//                       <p style={{ color: APP.text }} className="text-xs font-medium leading-snug">
//                         {n.title}
//                       </p>
//                       <p style={{ color: APP.textSm }} className="text-[11px] mt-0.5 line-clamp-2">
//                         {n.message}
//                       </p>
//                       <p style={{ color: APP.textXs }} className="text-[10px] mt-1">
//                         {timeAgo(n.createdAt)}
//                       </p>
//                     </div>
//                     {!n.read && (
//                       <span
//                         style={{ backgroundColor: APP.primary }}
//                         className="w-2 h-2 rounded-full flex-shrink-0 mt-1.5" />
//                     )}
//                   </div>
//                 );
//               })
//             )}
//           </div>

//           {/* Footer */}
//           {notifications.length > 0 && (
//             <div style={{ borderTop: `1px solid ${APP.borderLight}` }} className="px-4 py-2 text-center">
//               <button style={{ color: APP.primary }} className="text-xs font-medium hover:underline">
//                 View all notifications
//               </button>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default NotificationBell;



// NotificationBell.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Bell, Check, Briefcase, FileText, X } from 'lucide-react';
import axios from 'axios';
import { COMPANY_API_END_POINT } from '@/utils/constant';
import { APP } from './DashbordApplicationTab';
import { socket } from "@/socket";

const NOTIF_ICONS = {
  application: FileText,
  job: Briefcase,
  default: Bell,
};

const NotificationBell = () => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${COMPANY_API_END_POINT}/notifications`, {
        withCredentials: true,
      });
      if (res.data.status) {
        setNotifications(res.data.notifications || []);
        setUnreadCount(res.data.unreadCount || 0);
      }
    } catch (err) {
      console.error('Notification fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  fetchNotifications();  // load persisted notifications on mount
}, []);

 const markAsRead = (id) => {
  setNotifications((prev) =>
    prev.map((n) =>
      n._id === id ? { ...n, read: true } : n
    )
  );

  setUnreadCount((prev) => Math.max(0, prev - 1));
};

  const markAllAsRead = () => {
  setNotifications((prev) =>
    prev.map((n) => ({
      ...n,
      read: true,
    }))
  );

  setUnreadCount(0);
};

  // Close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Poll for new notifications every 30s
 useEffect(() => {
  socket.on("connect", () => {
    console.log("Socket Connected:", socket.id);
  });

  socket.on("newApplication", (data) => {
    console.log("New Application:", data);

    const newNotification = {
      _id: Date.now(),
      type: "application",
      title: "New Job Application",
      message: `${data.candidateName} applied for ${data.jobTitle}`,
      createdAt: data.createdAt,
      read: false,
    };

    setNotifications((prev) => [
      newNotification,
      ...prev,
    ]);

    setUnreadCount((prev) => prev + 1);
  });

  return () => {
    socket.off("newApplication");
  };
}, []);

  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    if (seconds < 60) return 'Just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
  onClick={() => setOpen(!open)}
  style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textSm }}
  className="relative p-2 border rounded-lg hover:bg-slate-50 transition-colors w-11 h-11 flex items-center justify-center">
  <Bell size={16} />
  {unreadCount > 0 && (
    <span
      style={{ backgroundColor: APP.red }}
      className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full text-white text-[10px] font-bold flex items-center justify-center">
      {unreadCount > 9 ? '9+' : unreadCount}
    </span>
  )}
</button>

      {open && (
        <div
          style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
          className="absolute right-0 mt-2 w-80 rounded-2xl shadow-lg z-50 overflow-hidden">

          {/* Header */}
          <div style={{ borderBottom: `1px solid ${APP.borderLight}` }}
            className="flex items-center justify-between px-4 py-3">
            <h3 style={{ color: APP.text }} className="text-sm font-semibold">Notifications</h3>
            {unreadCount > 0 && (
              <button
                onClick={markAllAsRead}
                style={{ color: APP.primary }}
                className="text-xs font-medium hover:underline">
                Mark all as read
              </button>
            )}
          </div>

          {/* List */}
          <div className="max-h-96 overflow-y-auto">
            {loading && notifications.length === 0 ? (
              <p style={{ color: APP.textXs }} className="text-sm text-center py-8">Loading...</p>
            ) : notifications.length === 0 ? (
              <div className="text-center py-8">
                <Bell size={24} style={{ color: APP.textXs }} className="mx-auto mb-2" />
                <p style={{ color: APP.textXs }} className="text-sm">No notifications yet</p>
              </div>
            ) : (
              notifications.map((n) => {
                const Icon = NOTIF_ICONS[n.type] || NOTIF_ICONS.default;
                return (
                  <div
                    key={n._id}
                    onClick={() => !n.read && markAsRead(n._id)}
                    style={{
                      backgroundColor: n.read ? APP.card : APP.primaryBg,
                      borderBottom: `1px solid ${APP.borderLight}`,
                    }}
                    className="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-slate-50 transition-colors">
                    <div
                      style={{ backgroundColor: APP.primaryBg, color: APP.primary }}
                      className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Icon size={14} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p style={{ color: APP.text }} className="text-xs font-medium leading-snug">
                        {n.title}
                      </p>
                      <p style={{ color: APP.textSm }} className="text-[11px] mt-0.5 line-clamp-2">
                        {n.message}
                      </p>
                      <p style={{ color: APP.textXs }} className="text-[10px] mt-1">
                        {timeAgo(n.createdAt)}
                      </p>
                    </div>
                    {!n.read && (
                      <span
                        style={{ backgroundColor: APP.primary }}
                        className="w-2 h-2 rounded-full flex-shrink-0 mt-1.5" />
                    )}
                  </div>
                );
              })
            )}
          </div>

          {/* Footer */}
          {notifications.length > 0 && (
            <div style={{ borderTop: `1px solid ${APP.borderLight}` }} className="px-4 py-2 text-center">
              <button style={{ color: APP.primary }} className="text-xs font-medium hover:underline">
                View all notifications
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;